import { render, staticRenderFns } from "./video_monitor.vue?vue&type=template&id=54d9708e"
import script from "./video_monitor.vue?vue&type=script&lang=js"
export * from "./video_monitor.vue?vue&type=script&lang=js"
import style0 from "./video_monitor.vue?vue&type=style&index=0&id=54d9708e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports